document.addEventListener("DOMContentLoaded", function() {
  const productNav = document.querySelector('.product-nav');
  if (!productNav) return;

  const sections = Array.from(document.querySelectorAll(".section"));
  const navLinks = Array.from(document.querySelectorAll('.product-nav a'));
  let navTop = productNav.offsetTop;
  let isFixed = false;
  let ticking = false;

  function updateNav() {
    const scrollY = window.pageYOffset;

    if (scrollY > navTop && !isFixed) {
      productNav.classList.add('fixed');
      isFixed = true;
    } else if (scrollY <= navTop && isFixed) {
      productNav.classList.remove('fixed');
      isFixed = false;
    }

    const currentSection = sections.find(section => {
      return scrollY >= section.offsetTop - productNav.offsetHeight - 50;
    });

    if (currentSection) {
      const activeLink = navLinks.find(link =>
        link.getAttribute('href') === '#' + currentSection.id
      );
      if (activeLink && !activeLink.classList.contains('active')) {
        navLinks.forEach(link => link.classList.remove('active'));
        activeLink.classList.add('active');
      }
    }

    ticking = false;
  }

  function expandAccordion(targetId) {
    const targetSection = document.getElementById(targetId);
    if (!targetSection || targetSection.classList.contains('active')) return;

    targetSection.classList.add('active');
    const contentWrapper = targetSection.querySelector('.section-content');
    if (contentWrapper) contentWrapper.setAttribute('aria-expanded', 'true');

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'product_accordion_toggle',
        accordion_section: targetId,
        accordion_action: 'open'
      });
    }
  }

  function smoothScrollTo(targetId) {
    const target = document.getElementById(targetId);
    if (!target) return;

    expandAccordion(targetId);

    setTimeout(function() {
      window.scrollTo({
        top: target.offsetTop - productNav.offsetHeight - 10,
        behavior: 'smooth'
      });
    }, 100);
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateNav);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', function() {
    navTop = productNav.offsetTop;
  }, { passive: true });

  productNav.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (link) {
      e.preventDefault();
      smoothScrollTo(link.getAttribute('href').substring(1));
    }
  });

  const firstLink = productNav.querySelector('a[href="#description"]');
  if (firstLink) firstLink.classList.add('active');
});